// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28zze","right":"styles_right__3ev8E"};